import { take, put, call } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import { Socket } from "phoenix"
import {
    WEBSOCKET_MESSAGE_CHANGE,
    WEBSOCKET_MESSAGE_REMOVE,
    WEBSOCKET_MESSAGE_ADD,
    WEBSOCKET_URL,
} from '../constants/actionTypes';

const createWebSocketConnection = (socketUrl) => {
    return new Promise((resolve, reject) => {
        if(!socketUrl) {
            reject('No socket url provided')
            return
        }

        let socket = new Socket(socketUrl)

        socket.connect()
        resolve(socket);
    });
}

function createSocketChannel(socket) {
    return eventChannel(emit => {

        const errorHandler = (errorEvent) => {
            const msg = errorEvent ? errorEvent.reason : "Unknown error"
            emit(new Error(msg))
        }

        let channel = socket.channel("realtime_updates", {})

        channel.join()
        channel.onError(errorHandler)

        const add = channel.on('add', (payload) => {
            emit({ type: WEBSOCKET_MESSAGE_ADD, payload })
        })
        const change = channel.on('change', (payload) => {
            emit({ type: WEBSOCKET_MESSAGE_CHANGE, payload })
        })
        const remove = channel.on('remove', (payload) => {
            emit({ type: WEBSOCKET_MESSAGE_REMOVE, payload })
        })

        const unsubscribe = () => {
            channel.off('add', add)
            channel.off('change', change)
            channel.off('remove', remove)
        }

        return unsubscribe
    })
}

export function* listenForSocketMessages() {
    const socketUrl = yield take(WEBSOCKET_URL)

    try {
        const socket = yield call(createWebSocketConnection, socketUrl.payload)
        const socketChannel = yield call(createSocketChannel, socket)

        while (true) {
            try {
                const action = yield take(socketChannel)
                yield put(action)
            } catch(err) {
                console.error('socket error:', err)
                // socketChannel.close()
            }
        }
    } catch(e) {
        console.error(e)
    }
}
